import { useTranslation } from "react-i18next";

export default function CourseTag({ tag, className }: { tag?: string; className?: string }) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`course.${key}`);

	if (!tag) {
		return <span></span>;
	}

	return (
		<span
			className={`bg-success-light mr-2 capitalize py-1 px-2 rounded-md text-text text-[12px] text-nowrap font-medium ${className}`}
		>
			{tag ?? ts("no-tag")}
		</span>
	);
}
